import React from 'react';
import { compose } from 'recompose';
import Paper from '@material-ui/core/Paper';
import { makeStyles } from '@material-ui/core';
import { FirebasePropType, withFirebase } from '../../../model/Firebase';
import { AuthUserPropTypes, withCurrentUser } from '../../../model/Session';
import Fields from '../fields';
import EditorBusinessDetailes from './editor';
import { isAuthorOrTranslator } from '../../../components/access';
import Loading from '../../../components/loading';
import { SectionTitle } from '../../../components/title';

const isReadOnly = authUser => !isAuthorOrTranslator(authUser);

const useStyles = makeStyles(theme => ({
  paper: {
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
}));

const NotesPanel = ({ place, firebase, authUser }) => {
  const readOnly = isReadOnly(authUser);
  const classes = useStyles();

  const handleUpdate = (newValue) => {
    if (place) {
      firebase.place(place.id)
        .set(newValue, { merge: true });
    }
  };

  const editorNotes = place ? (
    <EditorBusinessDetailes
      readOnly={readOnly}
      place={place}
      changeEvent={handleUpdate}
      property={Fields.fields.notes.id}
    />
  ) : (
    <Loading size={20} variant="h6" />
  );

  return (
    <Paper className={classes.paper}>
      <SectionTitle title="Notas" marginBottom />
      {editorNotes}
    </Paper>
  );
};

NotesPanel.defaultProps = {
  place: null,
};

NotesPanel.propTypes = {
  place: Fields.getPropTypes(),
  firebase: FirebasePropType.isRequired,
  authUser: AuthUserPropTypes.isRequired,
};

export default compose(
  withFirebase,
  withCurrentUser,
)(NotesPanel);
